import React from 'react';
import FormTouchspinContain from '../../../Componant/Forms/FormWidget/FormTouchspin';

const Touchspin = () => {
  return (
    <div className='page-body'>
      <FormTouchspinContain />
    </div>
  );
};

export default Touchspin;
